<template>
  <div>
    <div class="header">
      <p class="title">Escolha uma das formas de disparo da sua campanha</p>
    </div>

    <div v-if="campaign.type == ACTION_TYPE.ARD">
      <base-radio
        family="shot-method"
        :option="'dayMonth'"
        v-model="shotMethod"
        :checked="shotMethod"
        @click="() => openDrawer('dayMonth')"
        @change="() => openDrawer('dayMonth')"
        class="mt_25"
        hover
      >
        <p class="radio-label">Dia do mês</p>
      </base-radio>
      <div
        class="tags mt_15"
        v-if="
          shotMethod == 'dayMonth' &&
          nullishCoalescing(
            this,
            'campaign.configs.send_time.days_month',
            false
          )
        "
      >
        <div class="tag d-flex">
          <p class="shot-method-selected">
            Dia
            {{
              nullishCoalescing(
                this,
                'campaign.configs.send_time.days_month',
                ''
              )
            }}
          </p>
          <span>{{
            `\u00A0/ ${nullishCoalescing(
              this,
              'campaign.configs.send_time.time',
              ''
            )}`
          }}</span>
        </div>
      </div>

      <base-radio
        family="shot-method"
        :option="'dayWeek'"
        v-model="shotMethod"
        :checked="shotMethod"
        @click="() => openDrawer('dayWeek')"
        @change="() => openDrawer('dayWeek')"
        class="mt_15"
        hover
      >
        <p class="radio-label">Dia da semana</p>
      </base-radio>

      <div
        class="tags mt_15"
        v-if="shotMethod == 'dayWeek' && getDaysWeek().length > 0"
      >
        <div class="tag d-flex">
          <p
            class="shot-method-selected"
            v-for="(day, index) in getDaysWeek()"
            :key="index"
          >
            {{ `${index > 0 ? '-' : ''} ${daysWeekName[day]}\u00A0` }}
          </p>
          <span>{{
            `/ ${nullishCoalescing(
              this,
              'campaign.configs.send_time.time',
              ''
            )}`
          }}</span>
        </div>
      </div>
    </div>

    <div v-if="campaign.type == ACTION_TYPE.ARC">
      <base-radio
        hover
        class="mt_15"
        family="shot-method"
        v-model="shotMethod"
        :option="'onlyWhenItReachesACondition'"
        :checked="shotMethod === 'onlyWhenItReachesACondition'"
        @change="() => openDrawer('onlyWhenItReachesACondition')"
        @click="() => openDrawer('onlyWhenItReachesACondition')"
      >
        <p class="radio-label">
          Somente quando atingir uma condição (verificação diária)
        </p>
      </base-radio>
      <base-radio
        hover
        class="mt_15"
        family="shot-method"
        v-model="shotMethod"
        :option="'wheneverItReachesTheCondition'"
        :checked="shotMethod === 'wheneverItReachesTheCondition'"
        @change="() => openDrawer('wheneverItReachesTheCondition')"
        @click="() => openDrawer('wheneverItReachesTheCondition')"
      >
        <p class="radio-label">
          Sempre que atingir a condição segmentada (verificação diária)
        </p>
      </base-radio>
    </div>

    <div v-if="campaign.type == ACTION_TYPE.APA">
      <div class="row">
        <div class="col-xs-12 col-lg-3">
          <base-label text="Determine a data do disparo" class="mt_20" />
          <base-input
            placeholder="00/00/0000"
            class="mb_0"
            :masked="true"
            :mask="StringLanguage.dateMask"
            type="tel"
            v-model="date"
          />
        </div>
      </div>

      <div v-if="campaign.type === ACTION_TYPE.APA" class="row">
        <div class="col-xs-12 col-lg-3">
          <base-label text="Determine o horário do disparo" class="mt_20" />
          <base-input
            placeholder="00:00"
            class="mb_0"
            :masked="true"
            :mask="StringLanguage.timeMask"
            type="tel"
            v-model="time"
          />
        </div>
      </div>
    </div>

    <week-day-trigger
      v-if="shotMethod == 'dayWeek'"
      :campaign="campaign"
      :open.sync="drawers.dayWeek.open"
      :close.sync="drawers.dayWeek.close"
      @save="(d, c) => setCampaign(d, c)"
    />

    <monthly-trigger
      v-if="shotMethod == 'dayMonth'"
      :campaign="campaign"
      :open.sync="drawers.dayMonth.open"
      :close.sync="drawers.dayMonth.close"
      @save="(d, c) => setCampaign(d, c)"
    />

    <contemplation-time
      v-if="shotMethod == 'wheneverItReachesTheCondition'"
      :type="'wheneverItReachesTheCondition'"
      :campaign="campaign"
      :open.sync="drawers.wheneverItReachesTheCondition.open"
      :close.sync="drawers.wheneverItReachesTheCondition.close"
      @save="(d, c) => setCampaign(d, c)"
    />

    <contemplation-time
      v-if="shotMethod == 'onlyWhenItReachesACondition'"
      :type="'onlyWhenItReachesACondition'"
      :campaign="campaign"
      :open.sync="drawers.onlyWhenItReachesACondition.open"
      :close.sync="drawers.onlyWhenItReachesACondition.close"
      @save="(d, c) => setCampaign(d, c)"
    />

    <div class="d-flex justify-end mt_25">
      <base-button
        :loading="loading"
        text="Salvar campanha"
        @click="save()"
        :disabled="isInvalid()"
      />
    </div>
  </div>
</template>
<script>
import BaseButton from '@/components/Button';
import BaseLabel from '@/components/Label';
import BaseTextarea from '@/components/Textarea';
import BaseBadge from '@/components/Badge';
import BaseMessage from '@/components/Message';
import BaseRadio from '@/components/Radio';
import BaseInput from '@/components/Input';
import Utils from '@/utils';

import WeekDayTrigger from '@/containers/Performance/Steps/TimeDrawers/WeekDayTrigger';
import MonthlyTrigger from '@/containers/Performance/Steps/TimeDrawers/MonthlyTrigger';
import ContemplationTime from '@/containers/Performance/Steps/TimeDrawers/ContemplationTime.vue';

const ACTION_TYPE = {
  ARD: 'ARD',
  ARC: 'ARC',
  APA: 'APA',
  API: 'API',
};

const components = {
  BaseButton,
  BaseLabel,
  BaseTextarea,
  BaseBadge,
  BaseMessage,
  BaseRadio,
  BaseInput,
  WeekDayTrigger,
  MonthlyTrigger,
  ContemplationTime,
};

export default {
  components,
  props: {
    campaign: {
      type: Object,
      default: () => ({
        configs: { send_time: { days_week: [], time: '', interval: '' } },
      }),
    },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      date: null,
      time: null,
      dayMonth: null,
      shotMethod: Utils.nullishCoalescing(
        this,
        'campaign.configs.send_time.type'
      ),
      selectedDays: [],
      ACTION_TYPE,
      daysWeekName: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      drawers: {
        dayWeek: { open: false, close: false },
        dayMonth: { open: false, close: false },
        wheneverItReachesTheCondition: { open: false, close: false },
        onlyWhenItReachesACondition: { open: false, close: false },
      },
    };
  },
  methods: {
    nullishCoalescing(startPoint, jsonPath, defaultValue = null) {
      return Utils.nullishCoalescing(startPoint, jsonPath, defaultValue);
    },
    save() {
      if (this.campaign.type == ACTION_TYPE.ARC) {
        this.campaign.configs.send_time.type = this.shotMethod;
      } else {
        if (this.campaign.type == ACTION_TYPE.APA) {
          this.campaign.configs.send_time = {
            date_send: this.date,
            time: this.time,
          };
        }
        delete this.campaign.configs.send_time.type;
      }

      this.$emit('save', this.campaign, true);
    },
    isInvalid() {
      if (this.campaign.type != ACTION_TYPE.APA) {
        const { time } = this.nullishCoalescing(
          this,
          'campaign.configs.send_time',
          {
            time: '',
          }
        );

        if (!time || time.length !== 5) {
          return true;
        }

        const [hour, minutes] = time.split(':');
        if (
          minutes === undefined ||
          hour < 0 ||
          hour > 23 ||
          minutes < 0 ||
          minutes > 59
        ) {
          return true;
        }
      }

      switch (this.campaign.type) {
        case ACTION_TYPE.ARD:
          const { days_week, days_month } = this.nullishCoalescing(
            this,
            'campaign.configs.send_time',
            { days_month: null, days_week: [] }
          );

          return (
            (days_week && days_week.length == 0) ||
            days_month < 1 ||
            days_month > 31
          );
        case ACTION_TYPE.ARC:
          const { type, interval } = this.nullishCoalescing(
            this,
            'campaign.configs.send_time',
            { type: '', interval: null }
          );
          return !type || interval < 1;
        case ACTION_TYPE.APA:
          const { date } = this;
          if (!this.date || (date && date.length < 10)) {
            return true;
          }

          const [day, month, year] = this.date.split('/');
          const currentDate = new Date();
          if (year >= currentDate.getFullYear()) {
            return true;
          }

          if (month < 1 || month > 12) {
            return true;
          }

          const totalDays = new Date(year, month, 0).getDate();
          if (day < 1 || day > totalDays) {
            return true;
          }

          const onlyDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 1
          ).getTime();

          if (new Date(year, month - 1, day).getTime() >= onlyDate) {
            return true;
          }
          return false;
        default:
          return true;
      }
    },
    getDaysWeek() {
      return this.nullishCoalescing(
        this,
        `campaign.configs.send_time.days_week`,
        []
      );
    },
    openDrawer(drawer) {
      this.drawers[drawer].open = !this.drawers[drawer].open;
    },
    closeDrawer(drawer) {
      this.drawers[drawer].close = !this.drawers[drawer].close;
    },
    setCampaign(drawer, campaign) {
      this.$props.campaign.configs.send_time = campaign.configs.send_time;
      this.closeDrawer(drawer);
    },
  },
};
</script>

<style scoped>
.tabs {
  margin-top: 25px;
  align-items: stretch;
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 991px) {
  .tabs {
    padding-bottom: 50px;
  }
}
.tab-container {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  overflow: hidden;
}
@media screen and (max-width: 991px) {
  .tab-container {
    display: block;
  }
}
.tab-container .tab-options {
  display: flex;
  flex-direction: column;
  width: 20%;
  min-width: 320px;
  position: relative;
  background: #3a3c40;
  padding: 5px 0;
  border-radius: 5px;
  font-weight: 500;
}
@media screen and (max-width: 991px) {
  .tab-container .tab-options {
    width: 100%;
  }
}
.tab-container .tab-options .tab {
  padding: 20px 35px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  transition: all 0.1s ease;
  min-height: 100px;
}

.tab-container .tab-options .tab:not(.enabled) {
  cursor: not-allowed;
}

.tab-container .tab-options .tab .number {
  background: #46484d;
  border-radius: 50%;
  font-weight: bold;
  color: #aaaaab;
  font-size: 12px;
  margin-right: 17px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 15px;
}
@media screen and (max-width: 991px) {
  .tab-container .tab-options .tab {
    min-height: 80px;
    padding: 20px;
    transition: none;
  }
  .tab-container .tab-options .tab .number {
    width: 22px;
    height: 22px;
  }
  .tab-container .tab-options .tab .number.done {
    background: #288c79;
    color: #fff;
  }
}
.tab-container .tab-options .tab .name {
  font-size: 14px;
  line-height: 17px;
  color: #999;
  margin-bottom: 10px;
}
.tab-container .tab-options .tab p:not(.name) {
  color: #aaaaabd9;
  line-height: 15px;
  font-size: 12px;
}
.tab-container .tab-options .tab:not(.active).enabled:hover {
  background: #414347;
}
.tab-container .tab-content {
  width: 80%;
  padding: 25px;
  background: #3a3c40;
  overflow: auto;
  margin-left: 20px;
  border-radius: 5px;
  height: 100%;
}
@media screen and (max-width: 991px) {
  .tab-container .tab:after {
    content: '\f054';
    font-family: 'Font Awesome 5 Pro';
    position: absolute;
    right: 25px;
    font-size: 12px;
    color: #8c8c8c;
  }
  .tab-container .tab-content {
    width: 100%;
    margin: 0;
    position: relative;
    padding: 17px 20px;
  }
}
@media screen and (min-width: 992px) {
  .tab-container .tab.active {
    background: #4e3b47;
  }
  .tab-container .tab.active:before {
    content: '';
    height: 60px;
    width: 2px;
    position: absolute;
    left: 0;
    background: var(--default);
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .tab-container .tab-options .tab:not(:last-child) {
    margin-bottom: 15px;
  }
  .tab-container .tab-options .tab.active .number {
    background: var(--default);
    color: #fff;
  }
  .tab-container .tab-options .tab.active .name {
    color: var(--default);
    font-weight: bold;
  }
  .tab-container .tab-options .tab.active p:not(.name) {
    font-weight: bold;
  }
  .header-mobile {
    display: none;
  }
  .coupons {
    max-height: 600px;
    overflow: auto;
    padding-right: 10px;
    margin-right: -10px;
  }
}
.tab-container .tab-options:before {
  content: '';
  height: 85%;
  width: 2px;
  position: absolute;
  left: 45px;
  background: #aaaaab33;
  top: 0;
  bottom: 0;
  margin: auto;
}
@media screen and (max-width: 991px) {
  .tab-container .tab-options .tab .name {
    color: var(--label-secondary);
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
  }
  .tab-container .tab-options .tab p:not(.name) {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #aaaaabf2;
  }
  .tab-container .tab-options:before {
    left: 30px;
  }
  .tab-container .tab-options.step-1:before {
    background: linear-gradient(to bottom, #288c79 0%, #aaaaab33 0%);
  }
  .tab-container .tab-options.step-2:before {
    background: linear-gradient(to bottom, #288c79 15%, #aaaaab33 15%);
  }
  .tab-container .tab-options.step-3:before {
    background: linear-gradient(to bottom, #288c79 15%, #aaaaab33 35%);
  }
  .tab-container .tab-options.step-4:before {
    background: linear-gradient(to bottom, #288c79 35%, #aaaaab33 60%);
  }
  .tab-container .tab-options.step-5:before {
    background: linear-gradient(to bottom, #288c79 60%, #aaaaab33 70%);
  }
  .tab-container .tab-options.step-6:before {
    background: linear-gradient(to bottom, #288c79 80%, #aaaaab33 90%);
  }
  .tab-container .tab-options.step-7:before {
    background: linear-gradient(to bottom, #288c79 90%, #aaaaab33 100%);
  }
}
.title {
  color: #aaaaab;
  line-height: 19px;
  font-size: 16px;
  font-weight: bold;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ffffff17;
  padding-bottom: 25px;
  position: relative;
}
.help {
  display: flex;
  align-items: center;
  padding-bottom: 3px;
  border-bottom: 1px solid transparent;
  text-decoration: none;
  color: var(--label-secondary);
  cursor: pointer;
}
.help:hover {
  border-color: var(--label-secondary);
  color: #e6e6e6;
}
.help i {
  font-size: 15px;
  margin-right: 10px;
}
.help p {
  font-size: 12px;
  line-height: 15px;
  font-weight: bold;
}
.type-actions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 25px;
}
.type-actions .item {
  background: var(--box-up);
  border-radius: 5px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
}
.type-actions .item.inactive {
  opacity: 0.45;
}
.type-actions .item .icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: #4b4f54;
  margin-bottom: 10px;
}
.type-actions .item .icon i {
  color: var(--icon-inactive);
  font-size: 26px;
}
.type-actions .item p.title {
  color: var(--label-secondary);
  font-size: 14px;
  line-height: 17px;
}
.type-actions .item .description {
  color: #aaaaabf2;
  font-size: 12px;
  line-height: 20px;
  margin-top: 20px;
  padding: 20px 0;
  border-top: 1px solid #ffffff17;
  width: 100%;
  text-align: center;
}
.type-actions .item .radio {
  position: absolute;
  top: 20px;
  right: 10px;
}
.collapse .option {
  background: #45484d;
  border-radius: 5px;
  padding: 15px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
}
.collapse .option:hover {
  background: #494c52;
}
.collapse .option .chevron {
  position: absolute;
  right: 10px;
  color: var(--icon-inactive);
}
.collapse .option .chevron i {
  transition: all 0.2s;
  font-size: 11px;
}
.collapse .option .chevron.active i {
  transform: rotate(180deg);
}
.collapse .option i {
  font-size: 15px;
  margin-right: 10px;
  color: var(--icon-inactive);
}
.collapse .option p {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
}
.collapse .content {
  padding: 10px 0 5px 0;
}
.cost {
  background: #3a3c40;
  border: 1px solid #ffcc9914;
  border-radius: 12px;
  color: #d1802e;
  font-size: 14px;
  line-height: 17px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
}
.has.cost {
  background: #ffcc9914;
  border: 1px solid transparent;
}
.tags {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.tags .tag {
  color: var(--label-secondary);
  font-weight: bold;
  padding: 5px 10px;
  font-size: 10px;
  line-height: 12px;
  border-radius: 7px;
  border: 1px solid #ffffff17;
  margin-bottom: 5px;
  margin-right: 5px;
}
.coupons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.textarea-msg {
  position: relative;
}

.textarea .characters {
  position: absolute;
}

@media screen and (max-width: 991px) {
  .type-actions {
    grid-template-columns: repeat(1, 1fr);
  }
  .type-actions .item .description {
    padding-bottom: 0;
  }
  .coupons {
    grid-template-columns: repeat(1, 1fr);
  }
  .tabs-steps {
    color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #2d2f32;
    position: fixed;
    bottom: 60px;
    padding: 5px;
    left: 0;
    right: 0;
  }
  .header {
    display: none;
  }
  .header-mobile {
    color: var(--default);
    font-size: 12px;
    line-height: 15px;
    padding-bottom: 15px;
    padding-top: 3px;
    margin-bottom: 20px;
    font-weight: bold;
    border-bottom: 1px solid #ffffff17;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    position: relative;
  }

  .tags .tag {
    color: #aaaaabf2;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid #505359;
    margin-bottom: 5px;
    margin-right: 5px;
  }

  .tabs-steps .tab {
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    text-align: center;
  }

  .tabs-steps .tab.active {
    background: #45484d80;
  }

  .tabs-steps .tab p {
    color: var(--label-primary);
    font-size: 14px;
    line-height: 17px;
  }

  .tabs-steps .tab.active p {
    color: var(--label-secondary);
    font-weight: bold;
  }
  .progress-line,
  .progress-line > .done {
    position: absolute;
    width: 100%;
    height: 3px;
    left: 0;
    right: 0;
    top: 0;
  }
  .progress-line {
    background: #99999938;
  }
  .done {
    background: var(--default);
  }
  .help {
    padding-bottom: 0;
    border-bottom: none;
  }
  .cost {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    padding: 5px 20px;
  }
}

.characters {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  left: 0;
  padding: 0 20px;
}

.characters:before {
  position: absolute;
  left: 1px;
  top: -7.5px;
  content: '';
  background: #515159;
  width: calc(100% - 2px);
  height: 1px;
}

.characters .circle {
  position: relative;
  width: 30px;
  height: 30px;
}

.characters .circle svg {
  position: relative;
  width: 40px;
  height: 40px;
  transform: rotate(270deg);
}

.characters .circle svg circle {
  width: 30px;
  height: 30px;
  fill: none;
  stroke-width: 2;
  stroke: #000;
  transform: translate(5px, 5px);
  stroke-dasharray: 94;
  stroke-dashoffset: 94;
}
.characters .circle svg circle:nth-child(1) {
  stroke-dashoffset: 0;
  stroke: #515159;
}
.characters .circle svg circle:nth-child(2) {
  stroke: #ff3382;
}
.characters .circle .number {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  color: #aaaaab;
  font-weight: bold;
  transform: translate(5px, 5px);
}
.success-box {
  padding: 25px 20px 20px 20px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #344d4b;
}
.success-box i {
  color: #0dc59d;
  font-size: 45px;
}
.success-box p {
  color: #0dc59d;
  font-size: 14px;
  line-height: 17px;
  font-weight: bold;
  margin-top: 20px;
}
.custom-period {
  background: #45484d40;
  padding: 15px 15px 5px;
  margin-top: 20px;
}
.custom-period p {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
  font-weight: bold;
  margin-bottom: 5px;
}
.address-box {
  display: flex;
  align-items: stretch;
  margin: 10px 0;
}
.address-box .address {
  background: #45484d99;
  padding: 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  width: 100%;
  color: #aaaaaaed;
}
.address-box .address p {
  font-size: 12px;
  line-height: 15px;
  margin-left: 10px;
  font-weight: 300;
}
.address-box .address i {
  font-size: 15px;
  color: var(--icon-inactive);
}
.shot-method-selected,
.shot-method-selected + span {
  color: var(--label-secondary);
  font-size: 12px;
  line-height: 15px;
}

.week {
  display: flex;
}

.day {
  font-size: 1.2em;
  width: 29px;
  height: 29px;
  color: var(--label-primary);
  border: 1px solid #8c8c8c;
  border-radius: 3px;
  margin-right: 10px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.day.selected {
  color: white;
  border-color: var(--default);
  background: var(--default);
}
</style>
